import { Input, Flex, Text } from '@chakra-ui/react';
import { getIn } from 'formik';
import React, { useState } from 'react';

import { finleyAssert } from '@finley-technologies/common';

import { inputWidth } from './consts';
import {
  DeleteIconButton,
  EditIconButton,
  SaveIconButton,
  XIconButton,
} from 'packages/common-frontend/components/IconButton';
import { WipConfig } from 'packages/creditAgreements/ui/types';

const _areRecurringDateFields = (ipt: any): ipt is string[] => {
  if (!Array.isArray(ipt)) {
    return false;
  }
  return ipt.every((el) => typeof el === 'string');
};

export const AthenaRecurringDateField: React.FC<{
  wipConfig?: WipConfig;
  recurringDateField: string;
  basePropertyKey: string;
  idx: number;
}> = ({ recurringDateField, wipConfig, basePropertyKey, idx }) => {
  const [isDateFieldEditOpen, setIsDateFieldEditOpen] = useState<boolean>(
    false,
  );
  const [dateFieldState, setDateFieldState] = useState<string>(
    recurringDateField,
  );

  const changeDateField = (): void => {
    if (!wipConfig) {
      return;
    }

    const idxBasePropertyKey = `${basePropertyKey}[${idx}]`;
    const trimmedField = dateFieldState.trim();
    wipConfig.formProps.setFieldValue(idxBasePropertyKey, trimmedField);
  };

  const deleteDateField = (): void => {
    if (!wipConfig) {
      return;
    }

    const wipRecurringDateFields = getIn(
      wipConfig.formProps.values,
      basePropertyKey,
    );
    finleyAssert(
      _areRecurringDateFields(wipRecurringDateFields),
      `Retrieved non-recurring date fields structure when utilizing [key:${basePropertyKey}]`,
    );

    wipConfig.formProps.setFieldValue(
      basePropertyKey,
      wipRecurringDateFields.filter((_, loopIdx) => loopIdx !== idx),
    );
  };

  return (
    <Flex alignItems="center">
      <Text mr="3" width="40">
        Recurring Date Field:
      </Text>

      {isDateFieldEditOpen && wipConfig?.isMutateAllowed(basePropertyKey) ? (
        <>
          <Input
            type="text"
            mr="2"
            width={inputWidth}
            value={dateFieldState}
            onChange={(e) => setDateFieldState(e.target.value)}
            borderColor="blue.300"
            _hover={{ borderColor: 'blue.300' }}
          />
          <SaveIconButton
            ariaLabel="save recurring date field"
            label="Save Recurring Date Field"
            disabled={dateFieldState.length === 0}
            onClick={() => {
              changeDateField();
              setIsDateFieldEditOpen(false);
            }}
          />
          <XIconButton
            ariaLabel="close edit"
            label="Close Edit"
            onClick={() => {
              setDateFieldState(recurringDateField);
              setIsDateFieldEditOpen(false);
            }}
          />
        </>
      ) : (
        <>
          <Text width={inputWidth} mr="2" px="4" rounded="md">
            {recurringDateField}
          </Text>

          {wipConfig?.isMutateAllowed(basePropertyKey) && (
            <>
              <EditIconButton
                ariaLabel="edit recurring date field"
                label="Edit Recurring Date Field"
                onClick={() => setIsDateFieldEditOpen(true)}
              />
              <DeleteIconButton
                ariaLabel="delete recurring date field"
                label="Delete Recurring Date Field"
                onClick={() => {
                  deleteDateField();
                }}
              />
            </>
          )}
        </>
      )}
    </Flex>
  );
};
